import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";
import { utcHour } from "@/lib/studio";
import { StatTiles } from "@/components/stats/StatTiles";
import { ActivityCharts } from "@/components/stats/ActivityCharts";
import { UniverseTable } from "@/components/stats/UniverseTable";
import { CategoryBreakdown } from "@/components/stats/CategoryBreakdown";
import { GoalsPanel } from "@/components/stats/GoalsPanel";
import { streakInfo } from "@/components/stats/streakInfo";

const midnight = () => { const d = new Date(); d.setHours(0, 0, 0, 0); return utcHour(d); };

export default function StatsPage() {
  const { data, isLoading } = useQuery({ queryKey: ["me-stats-overview"], queryFn: () => api.get("/me/stats/overview", { params: { today: midnight() } }).then((r) => r.data) });
  const streak = data ? streakInfo(data.streak_hours) : null;
  return (
    <div className="min-h-screen bg-[#0B0D10]" data-testid="stats-page">
      <div className="mx-auto max-w-6xl px-6 py-10 sm:px-10">
        <Link to="/" className="inline-flex items-center gap-1 text-xs text-[#A8A090] transition-colors hover:text-[#F3EBDD]" data-testid="stats-back-link"><ChevronLeft className="h-3.5 w-3.5" />Your universes</Link>
        <div className="lf-label mt-8">Across every world you own</div>
        <h1 className="mt-2 font-display text-4xl text-[#F3EBDD] sm:text-5xl lg:text-6xl">Your stats</h1>
        {isLoading || !data ? <p className="mt-10 text-sm text-[#A8A090]">Gathering your numbers…</p> : (
          <div className="mt-10 space-y-8">
            <StatTiles universes={data.universes} streak={streak} />
            <ActivityCharts />
            <div className="grid gap-8 lg:grid-cols-[1.4fr_1fr]">
              <UniverseTable universes={data.universes} />
              <CategoryBreakdown categories={data.categories} />
            </div>
            <GoalsPanel stories={data.stories} streak={streak} />
          </div>
        )}
      </div>
    </div>
  );
}
